const initialState = {
  stepCompleted: false,
  damage: null,
  type: null,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_CLAIMS': {
      return initialState
    }

    case 'SET_DAMAGE': {
      const { damage, type } = action.payload.damage
      return {
        ...state,
        damage,
        type,
        stepCompleted: true,
      }
    }

    default: {
      return state
    }
  }
}
